@if(!columnGroup) {
<wj-flex-grid-column [header]="' '" [isReadOnly]="true" [isRequired]="false" [allowSorting]="false" [width]="30"
    [align]="'center'" [cssClass]="'excel-ignore'">
    @if(flexGridCtrl.selector) {
    <ng-template wjFlexGridCellTemplate [cellTypeStr]="'ColumnHeader'">
        <input type="checkbox" [checked]="flexGridCtrl.selector.isSelected"
            [indeterminate]="flexGridCtrl.selector.isIndeterminate" (click)="flexGridCtrl.selector.toggleAll()">
    </ng-template>
    <ng-template wjFlexGridCellTemplate [cellTypeStr]="'Cell'" let-cell="cell" let-row="row">
        <!-- @if(useCheckbox) {
        <input type="checkbox" [checked]="flexGridCtrl.selector.isRowSelected(row)"
            (click)="flexGridCtrl.selector.select(row, $event)">
        } @else {
        } -->
        @if(flexGridCtrl.selector.isRowSelected(row)){
        <span (click)="flexGridCtrl.selector.select(row, $event)">
            <i class="fa-solid fa-square-check"
                style="background-color: white !important;color: #0d6efd !important;"></i></span>
        }
        @else {
        <span (click)="flexGridCtrl.selector.select(row, $event)"><i class="fa-regular fa-square"></i></span>
        }

    </ng-template>
    }
</wj-flex-grid-column>
} @else {
<wj-flex-grid-column-group [header]="' '" [isReadOnly]="true" [isRequired]="false" [allowSorting]="false" [width]="30"
    [align]="'center'" [cssClass]="'excel-ignore'">
    @if(flexGridCtrl.selector) {
    <ng-template wjFlexGridCellTemplate [cellTypeStr]="'ColumnHeader'">
        <input type="checkbox" [checked]="flexGridCtrl.selector.isSelected"
            [indeterminate]="flexGridCtrl.selector.isIndeterminate" (click)="flexGridCtrl.selector.toggleAll()">
    </ng-template>
    <ng-template wjFlexGridCellTemplate [cellTypeStr]="'Cell'" let-cell="cell" let-row="row">
        <!-- @if(useCheckbox) {
        <input type="checkbox" [checked]="flexGridCtrl.selector.isRowSelected(row)"
            (click)="flexGridCtrl.selector.select(row, $event)">
        } @else {
        } -->
        @if(flexGridCtrl.selector.isRowSelected(row)){
        <span (click)="flexGridCtrl.selector.select(row, $event)">
            <i class="fa-solid fa-square-check"
                style="background-color: white !important;color: #0d6efd !important;"></i></span>
        }
        @else {
        <span (click)="flexGridCtrl.selector.select(row, $event)"><i class="fa-regular fa-square"></i></span>
        }

    </ng-template>
    }
</wj-flex-grid-column-group>
}